import { createAction, props } from '@ngrx/store';

export const commonIdAddVisitedPaper = createAction('[CommonIdVisitedPaper] Common Id Add Visited Paper', props<{ paperIds: string[] }>());
